"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../styles");

var _utils = _interopRequireDefault(require("./utils"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _locale = require("../locale");

var _component = require("../component");

var _Time = _interopRequireDefault(require("./Time"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Day =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Day, _PureComponent);

  function Day(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      hover: null
    };
    _this.handleNextMonth = _this.handleMonth.bind(_assertThisInitialized(_assertThisInitialized(_this)), 1);
    _this.handlePrevMonth = _this.handleMonth.bind(_assertThisInitialized(_assertThisInitialized(_this)), -1);
    _this.handleNextYear = _this.handleMonth.bind(_assertThisInitialized(_assertThisInitialized(_this)), 12);
    _this.handlePrevYear = _this.handleMonth.bind(_assertThisInitialized(_assertThisInitialized(_this)), -12);
    _this.handleMonthMode = _this.handleModeChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'month');
    _this.handleYearMode = _this.handleModeChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'year');
    _this.handleWeekLeave = _this.handleWeek.bind(_assertThisInitialized(_assertThisInitialized(_this)), null);
    _this.handleTimeChange = _this.handleTimeChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.formatWithDefaultTime = _this.formatWithDefaultTime.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Day.prototype;

  _proto.getDays = function getDays() {
    var current = this.props.current;

    if (this.cachedDate && _utils.default.isSameMonth(this.cachedDate, current) && this.cachedDays) {
      return this.cachedDays;
    }

    this.cachedDays = _utils.default.getDaysOfMonth(current);
    this.cachedDate = current;
    return this.cachedDays;
  };

  _proto.formatWithDefaultTime = function formatWithDefaultTime() {
    var _this$props = this.props,
        current = _this$props.current,
        defaultTime = _this$props.defaultTime;
    if (!defaultTime[0]) return current;
    return _utils.default.cloneTime(current, defaultTime[0], _utils.default.TIME_FORMAT);
  };

  _proto.handleDayClick = function handleDayClick(date) {
    var type = this.props.type;
    var current = this.formatWithDefaultTime();

    if (type === 'week') {
      if (date.getDay() === 0) {
        date = _utils.default.addDays(date, 1);
      }

      this.props.onChange(date, true, true);
    } else {
      var newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), current.getHours(), current.getMinutes(), current.getSeconds());
      this.props.onChange(newDate, true, type !== 'datetime');
    }
  };

  _proto.handleTimeChange = function handleTimeChange(time, change, end, mode) {
    this.props.onChange(time, true, false, mode);
  };

  _proto.handleWeek = function handleWeek(hover) {
    this.setState({
      hover: hover
    });
  };

  _proto.handleMonth = function handleMonth(month) {
    var _this$props2 = this.props,
        current = _this$props2.current,
        onChange = _this$props2.onChange;
    onChange(_utils.default.addMonths(current, month));
  };

  _proto.handleModeChange = function handleModeChange(mode) {
    this.props.onModeChange(mode);
  };

  _proto.handleDayHover = function handleDayHover(date) {
    this.props.onDayHover(date);
  };

  _proto.renderDay = function renderDay(date) {
    var _this$props3 = this.props,
        current = _this$props3.current,
        disabled = _this$props3.disabled,
        value = _this$props3.value,
        type = _this$props3.type,
        rangeDate = _this$props3.rangeDate,
        range = _this$props3.range,
        rangeTemp = _this$props3.rangeTemp;
    var hover = this.state.hover;
    var isDisabled = disabled ? disabled(date) : false;

    if (!isDisabled && typeof range === 'number' && rangeTemp) {
      if (_utils.default.compareAsc(date, _utils.default.addSeconds(rangeTemp, range)) > 0 || _utils.default.compareAsc(date, _utils.default.addSeconds(rangeTemp, -range)) < 0) {
        isDisabled = true;
      }
    }

    var classList = [_utils.default.isSameDay(date, this.today) && 'today', current.getMonth() !== date.getMonth() && 'other-month', isDisabled && 'disabled'];
    var hoverClass;
    var hoverProps = {};

    if (type === 'week') {
      hoverProps.onMouseEnter = this.handleWeek.bind(this, date);
      hoverProps.onMouseLeave = this.handleWeekLeave;

      if (_utils.default.isSameWeek(date, value)) {
        hoverClass = (0, _styles.datepickerClass)('active', date.getDay() === 0 && 'hover-start', date.getDay() === 6 && 'hover-end');
      } else if (hover && _utils.default.isSameWeek(date, hover)) {
        hoverClass = (0, _styles.datepickerClass)('hover', date.getDay() === 0 && 'hover-start', date.getDay() === 6 && 'hover-end');
      }
    } else if (rangeDate && current.getMonth() === date.getMonth()) {
      hoverProps.onMouseEnter = this.handleDayHover.bind(this, date);
      hoverClass = (0, _styles.datepickerClass)(_utils.default.compareAsc(rangeDate[0], date) <= 0 && _utils.default.compareAsc(rangeDate[1], date) >= 0 && 'hover', _utils.default.isSameDay(rangeDate[0], date) && 'hover-start active', _utils.default.isSameDay(rangeDate[1], date) && 'hover-end active');
    } else if (value) {
      classList.push(_utils.default.isSameDay(date, value) && 'active');
    }

    return _react.default.createElement("div", _extends({
      key: date.getTime(),
      className: hoverClass,
      onClick: isDisabled ? undefined : this.handleDayClick.bind(this, date)
    }, hoverProps), _react.default.createElement("span", {
      className: _styles.datepickerClass.apply(void 0, classList)
    }, date.getDate()));
  };

  _proto.renderTimepicker = function renderTimepicker() {
    var _this$props4 = this.props,
        rangeDate = _this$props4.rangeDate,
        index = _this$props4.index,
        showTimePicker = _this$props4.showTimePicker;
    if (this.props.type !== 'datetime') return undefined;
    if (!showTimePicker) return undefined;
    var format = this.props.format;

    if (/^[T|t]$/.test(format)) {
      format = 'HH:mm:ss';
    } else {
      var match = format.match(/[H|h].*/); // eslint-disable-next-line

      if (match) format = match[0];
    }

    var value = rangeDate ? _utils.default.toDateWithFormat(rangeDate[index], format) : this.props.value;
    if (!value) return undefined;
    return _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('datetime')
    }, _react.default.createElement(_Time.default, _extends({}, this.props, {
      format: format,
      value: value,
      onChange: this.handleTimeChange
    })), _react.default.createElement("span", null, _utils.default.format(value, format)));
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props5 = this.props,
        current = _this$props5.current,
        min = _this$props5.min,
        max = _this$props5.max;
    var days = this.getDays();
    this.today = _utils.default.newDate();
    return _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('day-picker')
    }, _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('header')
    }, _react.default.createElement(_Icon.default, {
      name: "AngleDoubleLeft",
      disabled: min && current.getFullYear() <= min.getFullYear(),
      onClick: this.handlePrevYear
    }), _react.default.createElement(_Icon.default, {
      name: "AngleLeft",
      disabled: min && _utils.default.compareMonth(current, min, 1) <= 0,
      onClick: this.handlePrevMonth
    }), _react.default.createElement("span", {
      className: (0, _styles.datepickerClass)('ym')
    }, _react.default.createElement("span", {
      onClick: this.handleYearMode
    }, current.getFullYear()), _react.default.createElement("span", {
      onClick: this.handleMonthMode
    }, (0, _locale.getLocale)('monthValues.short')[current.getMonth()])), _react.default.createElement(_Icon.default, {
      name: "AngleRight",
      disabled: max && _utils.default.compareMonth(current, max, -1) >= 0,
      onClick: this.handleNextMonth
    }), _react.default.createElement(_Icon.default, {
      onClick: this.handleNextYear,
      disabled: max && current.getFullYear() >= max.getFullYear(),
      name: "AngleDoubleRight"
    })), _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('week')
    }, (0, _locale.getLocale)('weekdayValues.narrow').map(function (w) {
      return _react.default.createElement("span", {
        key: w
      }, w);
    })), _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('list')
    }, days.map(function (d) {
      return _this2.renderDay(d);
    })), _react.default.createElement("div", {
      style: {
        flex: 1
      }
    }), this.renderTimepicker());
  };

  return Day;
}(_component.PureComponent);

Day.propTypes = {
  current: _propTypes.default.object.isRequired,
  disabled: _propTypes.default.func,
  format: _propTypes.default.string,
  index: _propTypes.default.number,
  max: _propTypes.default.object,
  min: _propTypes.default.object,
  onChange: _propTypes.default.func.isRequired,
  onDayHover: _propTypes.default.func,
  onModeChange: _propTypes.default.func.isRequired,
  range: _propTypes.default.number,
  rangeDate: _propTypes.default.array,
  rangeTemp: _propTypes.default.object,
  showTimePicker: _propTypes.default.bool,
  type: _propTypes.default.string.isRequired,
  value: _propTypes.default.object,
  defaultTime: _propTypes.default.array
};
var _default = Day;
exports.default = _default;